//
//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
export default {
  props: {
    width: {
      type: String,
      default: '450px'
    },
    height: {
      type: String,
      default: '250px'
    },
    top: {
      type: String,
      default: '40px'
    }
  },
  data: function data() {
    return {
      chart: 'chart10'
    };
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.initBarChart();
    }, 1000);
    this.$nextTick(function () {});
  },
  methods: {
    initBarChart: function initBarChart(data, type, val) {
      //	趋势图
      var seriesData = [];
      var xAxisData = ['2018-01', '2018-02', '2018-03', '2018-04', '2018-05', '2018-06', '2018-07', '2018-08', '2018-09', '2018-10', '2018-11', '2018-12'];
      var legendData = ['投诉量', '解决量', '投诉解决率', '投诉量1', '解决量1', '投诉解决率1', '投诉量2', '解决量3', '投诉解决率3'];
      var title = "多横向折线图";
      var serieData = [];
      var metaDate = [[120, 140, 100, 120, 300, 230, 130, 170, 140, 120, 300, 230], [200, 120, 300, 200, 170, 300, 200, 180, 200, 190, 300, 200], [100, 200, 140, 300, 200, 180, 100, 300, 230, 130, 100, 300], [20, 40, 10, 12, 30, 23, 13, 17, 14, 12, 30, 23], [20, 10, 30, 20, 10, 30, 20, 18, 20, 19, 30, 20], [10, 0, 10, 30, 20, 18, 10, 30, 23, 13, 10, 30], [12, 15, 2, 5, 22, 5, 8, 5, 1, 2, 2, 5], [45, 4, 15, 8, 1, 5, 45, 12, 4, 5, 12, 545], [4, 5, 45, 1, 8, 5, 15, 25, 65, 45, 65, 85]];

      for (var v = 0; v < legendData.length; v++) {
        var serie = {
          name: legendData[v],
          type: 'line',
          smooth: true,
          //是否平滑
          showAllSymbol: false,
          // symbol: 'image://./static/images/guang-circle.png',
          symbol: 'circle',
          symbolSize: 2,
          lineStyle: {
            normal: {
              color: "#00b3f4"
            }
          },
          itemStyle: {
            color: "#00b3f4"
          },
          tooltip: {
            show: true
          },
          areaStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(0,179,244,0.3)'
              }, {
                offset: 1,
                color: 'rgba(0,179,244,0)'
              }], false),
              shadowColor: 'rgba(0,179,244, 0.9)',
              shadowBlur: 20
            }
          },
          data: metaDate[v]
        };
        serieData.push(serie);
      }

      var option = {
        // backgroundColor: '#080b30',
        title: {
          // text: '多线图',
          textStyle: {
            align: 'center',
            color: '#fff',
            fontSize: 20
          },
          top: '5%',
          left: 'center'
        },
        legend: {
          show: true,
          icon: "rect",
          itemWidth: 14,
          itemHeight: 5,
          itemGap: 10,
          right: "35%",
          top: 0,
          textStyle: {
            fontSize: 10,
            color: "#ccc"
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            lineStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0,
                  color: 'rgba(0, 255, 233,0)'
                }, {
                  offset: 0.5,
                  color: 'rgba(255, 255, 255,1)'
                }, {
                  offset: 1,
                  color: 'rgba(0, 255, 233,0)'
                }],
                global: false
              }
            }
          }
        },
        grid: {
          top: '15%',
          left: '5%',
          right: '5%',
          bottom: '15%' // containLabel: true

        },
        xAxis: [{
          type: 'category',
          axisLine: {
            show: true
          },
          splitArea: {
            // show: true,
            color: '#f00',
            lineStyle: {
              color: '#f00'
            }
          },
          axisLabel: {
            color: '#fff'
          },
          splitLine: {
            show: false
          },
          boundaryGap: false,
          data: ['A', 'B', 'C', 'D', 'E', 'F']
        }],
        yAxis: [{
          type: 'value',
          min: 0,
          // max: 140,
          splitNumber: 4,
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255,255,255,0.1)'
            }
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            show: false,
            margin: 20,
            textStyle: {
              color: '#d1e6eb'
            }
          },
          axisTick: {
            show: false
          }
        }],
        series: serieData
      };
      var chart = this.$refs[this.chart];
      var myChart = this.$echarts.init(chart);
      myChart.setOption(option);

      window.onresize = function () {
        myChart.resize();
      };
    }
  }
};